export default function NotFoundPage() {
    return (
      <main className="absolute h-screen w-screen bg-gradient-to-r from-[#090F16] via-[#081830] to-[#08121C] flex justify-center items-center">
        <div className="w-auto p-6 text-center text-red-600 text-xl bg-black/20 container mx-auto backdrop-blur-2xl">
          <p className="font-bold">404 - Page Not Found</p>
        </div>
      </main>
    );
  }
  